import { i18n } from '@lingui/core';
import { WearDataForm } from 'providers/api';
import { Weaken } from 'utils';
import {
  number,
  object,
  SchemaOf,
  string
} from 'yup';

export type WearDataInputs = Weaken<WearDataForm>;

const wearDataSchema: SchemaOf<WearDataInputs> = object().shape({
  inspectionDate: object()
    .shape({})
    .required(i18n._('A planned pour date is required'))
    .nullable(),
  ...(Array(8).reduce((accumulator, item, index) => ({
    ...accumulator,
    [`point${index + 1}`]: number().typeError(`Point ${index + 1} must be a number`).moreThan(0, `Point ${index + 1} must be greater than zero`),
  }), {})),
  inspectionPointId: string().required(i18n._('An inspection point is required')),
});

export default wearDataSchema;
